import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Loading, Crumbs, PromiseBadge, fmtMoney, ShareMenu } from "@/components/common";

export default function EntityDetail() {
  const { id } = useParams();
  const [e, setE] = useState(null);
  useEffect(() => { api.get(`/entities/${id}`).then((r) => setE(r.data)).catch(() => setE(false)); }, [id]);

  if (e === null) return <Loading />;
  if (e === false) return <div className="max-w-4xl mx-auto px-6 py-20 text-center text-slate-400">Perfil no encontrado.</div>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-10" data-testid="entity-detail">
      <Crumbs items={[{ label: "Perfiles", to: "/perfiles" }, { label: e.name }]} />
      <div className="flex justify-end -mt-2 mb-2"><ShareMenu title={e.name} /></div>
      <span className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">{e.role_title || e.entity_type}</span>
      <h1 className="font-heading font-black text-3xl md:text-4xl text-slate-900 tracking-tight mt-2 mb-4">{e.name}</h1>
      {e.description && <p className="text-slate-700 leading-relaxed mb-8">{e.description}</p>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h3 className="font-heading font-bold text-lg text-slate-900 mb-3">Investigaciones relacionadas</h3>
          {e.related_investigations?.length ? (
            <div className="space-y-3">
              {e.related_investigations.map((iv) => (
                <Link key={iv.id} to={`/fiscalizacion/${iv.id}`} className="block bg-white rounded-lg border border-slate-200 p-4 hover:shadow-md transition-all">
                  <p className="font-semibold text-slate-900 text-sm">{iv.title}</p>
                  {iv.amount != null && <p className="text-sm text-rose-500 mt-1">{fmtMoney(iv.amount)}</p>}
                </Link>
              ))}
            </div>
          ) : <p className="text-sm text-slate-400">Sin investigaciones registradas.</p>}
        </div>
        <div>
          <h3 className="font-heading font-bold text-lg text-slate-900 mb-3">Promesas relacionadas</h3>
          {e.related_promises?.length ? (
            <div className="space-y-3">
              {e.related_promises.map((p) => (
                <div key={p.id} className="bg-white rounded-lg border border-slate-200 p-4">
                  <div className="flex items-start justify-between gap-2">
                    <p className="font-semibold text-slate-900 text-sm">{p.title}</p>
                    <PromiseBadge status={p.promise_status} />
                  </div>
                </div>
              ))}
            </div>
          ) : <p className="text-sm text-slate-400">Sin promesas registradas.</p>}
        </div>
      </div>
    </div>
  );
}
